import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Card, Row, Col, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import { Redirect } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { UserContext } from "../../../context/UserContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../../css/course-catelog.css";
const Changepasswordpage = () => {
  const context = useContext(UserContext);
  const [oldemail, setOldemail] = useState("");
  const [oldpswd, setOldpswd] = useState("");
  const [newpassword, setNewpassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [currentpswd, setCurrentpswd] = useState("");
  const [lemail, setLemail] = useState("");
  const [ischanged, setIschanged] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Update the document title using the browser API
    getlogindetails();
  }, []);
  const getlogindetails = async () => {
    var formData = new FormData();
    formData.append("access_token", localStorage.getItem("token"));
    axios
      .post("Login/changePassword", formData)
      .then((res) => {
        if (res.data.status === "200") {
          setOldemail(res.data.oldemail);

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    savepassword();
  };

  const savepassword = async () => {
    setLoading(true);
    if (newpassword === "" || confirmpassword === "" || currentpswd === "") {
      toast.error("All Fields are mandatory");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (currentpswd === newpassword) {
      toast.error("Current Password and New Password should not be same");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (newpassword.length < 3) {
      toast.error("lenght New Password should be 3 characters  ");
      await sleep(3000);
      setLoading(false);
      return;
    } else if (newpassword !== confirmpassword) {
      toast.error("New Password and Confirm Password should be same");
      await sleep(3000);
      setLoading(false);
      return;
    } else {
      var formData = new FormData();
      formData.append("newpassword", newpassword);
      formData.append("confirmpassword", confirmpassword);
      formData.append("currentpswd", currentpswd);
      formData.append("email", oldemail);
      formData.append("access_token", localStorage.getItem("token"));

      await axios
        .post("Login/savechangePassword", formData)

        .then((res) => {
          // console.log("res  ====");
          if (res.data.status === "200") {
            if (res.data.msg) {
              toast.success(res.data.msg);
              setIschanged(true);
            } else {
              toast.error(res.data.errormsg);
              setCurrentpswd("");
              setNewpassword("");
              setConfirmpassword("");
              setLoading(false);
            }
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };

  if (ischanged === true) {
    return <Redirect to="/Signin" />;
  }
  if (!context.user?.email) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      <section class="padding-default2">
        <Row>
          <Col sm={12}>
            <br />
            <Row>
              <Col sm={3}></Col>

              <Col sm={6}>
                <Card className="p-3">
                  <CardBody>
                    <div class="row padding-default">
                      <div class="col-sm-12">
                        <img
                          alt="img"
                          src="assets\images\eduplusnow.jpg"
                          height="80px"
                          width="300"
                          style={{marginLeft:"-4rem",marginTop:"-1rem",paddingBottom:"1rem"}}
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <form>
                          <div class="row">
                            <label class="input_label">
                              {" "}
                              <FontAwesomeIcon icon={faEnvelope} />
                              &nbsp; Your Email
                            </label>
                            <input
                              class="form-control"
                              type="text"
                              name="oldemail"
                              id="oldemail"
                              value={oldemail}
                              readOnly
                            />
                            <br />
                            <br />
                            <label class="input_label">
                              {" "}
                              <FontAwesomeIcon icon={faKey} />
                              &nbsp; Current Password
                            </label>
                            <input
                              class="form-control"
                              type="text"
                              value={currentpswd}
                              onChange={(e) => setCurrentpswd(e.target.value)}
                              id="currentpswd"
                              name="currentpswd"
                            />
                            <br />
                            <br />
                            <label class="input_label">
                              {" "}
                              <FontAwesomeIcon icon={faKey} />
                              &nbsp; New Password
                            </label>
                            <input
                              class="form-control"
                              type="text"
                              value={newpassword}
                              onChange={(e) => setNewpassword(e.target.value)}
                              id="newpassword"
                              name="newpassword"
                            />
                            <br />
                            <br />
                            <label class="input_label">
                              {" "}
                              <FontAwesomeIcon icon={faKey} />
                              &nbsp; Confirm Password
                            </label>
                            <input
                              class="form-control"
                              type="text"
                              value={confirmpassword}
                              onChange={(e) =>
                                setConfirmpassword(e.target.value)
                              }
                              id="confirmpassword"
                              name="confirmpassword"
                            />
                          </div>
                          <br />

                          <div className="root">
                            <div className="wrapper">
                              <Button
                                variant="contained"
                                color="primary"
                                disabled={loading}
                                onClick={(e) => handleSubmit(e)}
                              >
                                Change Password
                              </Button>

                              {loading === true ? (
                                <CircularProgress
                                  size={24}
                                  color="green"
                                  className="buttonProgress1"
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col sm={3}></Col>
            </Row>
            <br />
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default Changepasswordpage;
